<template>
  <v-container fluid>
    <v-combobox
      v-model="s"
      :items="items"
      :search-input.sync="search"
      :label="label"
      item-value="id"
      multiple
      persistent-hint
      small-chips
      no-filter
    >
      <template v-slot:selection="{ attrs, item, parent}">
        <v-chip
          label
          outlined
          v-bind="attrs"
        >
          <span class="pr-2">
            {{ item }}
          </span>
          <v-icon
            small
            @click="parent.selectItem(item)"
          >
            mdi-close
          </v-icon>
        </v-chip>
      </template>
      <template v-slot:item="{ item }">
        {{ item }}
      </template>

      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Нет ролей
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-combobox>
  </v-container>
</template>
<script>
  export default {
      props: {
          select: {
              type: Array
          },
          items: {
              type: Array
          },
          openDialog: {
            type: Boolean
          },
          label: {
            type: String
          }
      },
    data: () => ({
      s: [],
      search: null
    }),
    mounted () {
      this.s = this.select
    },
    watch: {
      openDialog (val) {
          this.s = []
          if (this.select !== undefined) {
             this.s = this.select
          }
      },
        s () {
          this.$emit('selected', this.s)
        }
    }
  }
</script>
